<template>
  <div class="min-h-screen flex flex-col bg-neutral-50 text-neutral-900">
    <!-- Header -->
    <header class="bg-white border-b shadow-sm p-4 flex justify-between items-center">
      <div class="flex items-center gap-2">
        <NavigationDropdown>
          <template #trigger="{ open }">
            <button
              type="button"
              class="p-1 rounded hover:bg-neutral-100 transition-colors"
              aria-haspopup="true"
              :aria-expanded="open"
            >
              <Logo />
            </button>
          </template>
        </NavigationDropdown>
        <h1 class="text-2xl font-semibold">{{ moduleName }}</h1>
      </div>
      <div class="flex items-center gap-4">
        <router-link to="/notifications" class="relative p-1 rounded hover:bg-neutral-100" title="Уведомления">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <span
            v-if="unreadCount > 0"
            class="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[11px] leading-none font-semibold text-white bg-red-500 rounded-full"
          >
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </span>
        </router-link>
        <span class="text-sm font-medium">{{ user.first_name }} {{ user.last_name }}</span>
        <button
          @click="changeUser"
          class="px-4 py-1.5 bg-neutral-900 text-white text-sm rounded hover:bg-neutral-700"
        >
          Сменить пользователя
        </button>
        <button
          @click="logout"
          class="px-4 py-1.5 bg-neutral-900 text-white text-sm rounded hover:bg-neutral-700"
        >
          Выйти
        </button>
      </div>
    </header>

    <main class="flex-1">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import { useNotificationsStore } from '@/stores/notifications';
import Logo from '@/components/Logo.vue';
import NavigationDropdown from '@/components/navigation/NavigationDropdown.vue';

export default {
  components: {
    Logo,
    NavigationDropdown,
  },
  data() {
    return {
      userStore: useAuthStore(),
      notificationsStore: useNotificationsStore(),
    };
  },
  computed: {
    user() {
      return this.userStore?.user;
    },
    unreadCount() {
      return this.notificationsStore?.unreadCount || 0;
    },
    moduleName() {
      let name = 'Рабочий стол #' + this.$route.params.id;
      if (this.user?.modules) {
        const found = this.user.modules.find((m) => m.id == this.$route.params.id);
        if (found) return found.name;
      }
      if (this.user?.start_module?.id == this.$route.params.id) {
        return this.user.start_module.name;
      }
      return name;
    },
  },
  methods: {
    changeUser() {
      this.userStore.changeUser().catch((error) => {
        console.error('Ошибка при смене пользователя:', error);
        alert('Произошла ошибка при смене пользователя');
      });
    },
    logout() {
      this.userStore
        .logout()
        .then(() => {
          window.location.href = '/login';
        })
        .catch((error) => {
          console.error('Ошибка при выходе из системы:', error);
          alert('Произошла ошибка при выходе из системы');
        });
    },
  },
};
</script>
